(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@korzio/djv-draft-04"));
	else if(typeof define === 'function' && define.amd)
		define(["@korzio/djv-draft-04"], factory);
	else if(typeof exports === 'object')
		exports["djv"] = factory(require("@korzio/djv-draft-04"));
	else
		root["djv"] = factory(root["@korzio/djv-draft-04"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_29__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition